<template>
    <div class="sw">
        <swiper :options="swiperOption" ref="mySwiper">
            <div class="parallax-bg" slot="parallax-bg" data-swiper-parallax="-23%"></div>
            <!-- slides -->
            <swiper-slide class="slide-1">
                <router-link :to="{name: 'Album', params: {id: 'lucka'}}">
                    <span class="title has-text-lime" data-swiper-parallax="-100">
                        Lučka
                    </span>
                    <span class="subtitle has-text-lime" data-swiper-parallax="-200">Naša lučka</span>
                    <span class="text" data-swiper-parallax="-300">
                        <span class="swipper-green">To je moj prvi dan doma. Sem majhna, a videti že velika. Stara sem bila 3 leta in pol. Imam prijatelja, ki prihaja za mano iz prvega doma: Figaro</span>
                  </span>
                </router-link>

            </swiper-slide>
            <swiper-slide class="slide-2">

                <router-link :to="{name: 'Album', params: {id: 'figaro'}}">
                    <span class="title has-text-mediumspringgreen" data-swiper-parallax="-100">
                        Figaro
                    </span>
                    <span class="subtitle has-text-mediumspringgreen" data-swiper-parallax="-200">Navihan muc</span>
                    <span class="text" data-swiper-parallax="-300">
                        <span class="swipper-green">Hej, jaz sem FIGARO! Nisem pes, sem pravi mačkon. Imam sestro Lučko, ki je ogromna in se je občasno bojim</span>
                  </span>
                </router-link>
            </swiper-slide>
            <swiper-slide class="slide-3">
                <router-link :to="{name: 'Album', params: {id: 'ola'}}">
                    <span class="title has-text-springgreen" data-swiper-parallax="-100">
                        Ola
                    </span>
                    <span class="text" data-swiper-parallax="-300">
                        <span class="swipper-green">Mlada navihana, ljubeča, domiselna nemška ovčarka, ki smo jo izgubili v tragični nesreči. Vedno boš v naših srcih, Ola.</span>
                    </span>
                    <span class="text" data-swiper-parallax="-300">
                        <span class="swipper-green">
                            2016-2017
                        </span>
                    </span>
                </router-link>
            </swiper-slide>
            <swiper-slide class="slide-4">
                <router-link :to="{name: 'Album', params: {id: 'tesi'}}">
                    <span class="title has-text-lime" data-swiper-parallax="-100">
                         Tesi
                    </span>
                    <span class="text" data-swiper-parallax="-300">
                        <span class="swipper-green">Moja, naša dolgoletna prijateljica in spremljevalka, o kateri bi lahko pisala knjigo brez konca. Vedno boš med nami, Tesi.</span>
                    </span>
                    <span class="text" data-swiper-parallax="-300">
                        <span class="swipper-green">
                            2004-2016
                        </span>
                    </span>
                </router-link>
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <!-- <div class="swiper-scrollbar"   slot="scrollbar"></div> -->
        </swiper>
    </div>
</template>
<script>
import 'swiper/dist/css/swiper.css';
import { ApiHome } from '../../../.env';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
    name: 'app-swipper',
    components: {
        swiper,
        swiperSlide
    },

    data() {

        return {
            swiperOption: {
                watchOverflow: true,
                // some swipper options
                // lazy: true,
                speed: 600,
                parallax: true,
                // observer: true,
                // observeParents: true,
                loop: true,
                // effect: 'fade',
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: true
                },
                initialSlide: 0,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    type: 'progressbar'
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
        };
    },

    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        },
    },

    mounted() {
        // current swiper instance
        // console.log('this is current swiper instance object', this.swiper);
        // this.swiper.slideTo(3, 1000, true)
    }

}

</script>
<style lang="scss">
@import '../../../style/app.scss';

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background: $limegreen !important;
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
    // background-image: none;
    // color: $lime;
}

.swiper-slide {
    font-size: 18px;
    color: $limegreen;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 40px 60px;
    background-color: transparent!important;
    justify-content: space-around!important;
    height: auto !important;
    background-position: center;
    background-size: cover;
    min-height: 800px;
    // paths in variables.css
    &.slide-1 {
        background-image: url(#{$sliderPath}/#{$slide1})
    }
    &.slide-2 {
        background-image: url(#{$sliderPath}/#{$slide2})
    }
    &.slide-3 {
        background-image: url(#{$sliderPath}/#{$slide3})
    }
    &.slide-4 {
        background-image: url(#{$sliderPath}/#{$slide4})
    }

    a {
        display: inline-block;
        width: 100%;
        height: 100%;
        color: $white;
    }
    .title,
    .subtitle {
        @extend .embeded;
        color: rgba(0, 255, 0, 0.6);
        opacity: 0.8;
        display: block;
    }

    .subtitle {
        font-size: 2rem;
        // color: $limegreen !important;
    }

    .text {
        display: block;
        font-size: 1.1rem;
        max-width: 400px;
        line-height: 2;
        color: $white;
    }
}

.swiper-container {
    .swiper-button-prev, .swiper-container-rtl .swiper-button-next,
    .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
        background-image:none !important;
    }
    .swiper-button-next::before {
        color:$limegreen;
        content:"\f105";
        font-family: "FontAwesome";
        font-size:5rem;
    }
    .swiper-button-prev::before {
        color:$limegreen;
        content:"\f104";
        font-family: "FontAwesome";
        font-size:5rem;
    }
}

.swipper-green {
    display:inline-block;
    padding: 10px 20px;
    background: rgba(0,0,0,0.3);
    border-radius: 3px 25px 25px 3px;
    color: #4ded30;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/swipper/Swipper.vue